import { render, staticRenderFns } from "./viewClaim.vue?vue&type=template&id=3d22c63b&scoped=true"
import script from "./viewClaim.vue?vue&type=script&lang=js"
export * from "./viewClaim.vue?vue&type=script&lang=js"
import style0 from "./viewClaim.vue?vue&type=style&index=0&id=3d22c63b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d22c63b",
  null
  
)

export default component.exports